import composeReduxMiddlewares from '../../../helpers/composeReduxMiddlewares'
import loadingBarMiddleware from './loadingBar'
import raceMiddleware from './race'
import serverErrorMiddleware from './serverError'

export default composeReduxMiddlewares(
  loadingBarMiddleware,
  raceMiddleware,
  serverErrorMiddleware
)
